/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import { CustomCard, CustomTable } from 'src/components'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { integrationProjectsListColumns } from 'src/core/table-columns'
import IntegrationTransactionListHeader from './IntegrationProjectsListHeader/IntegrationProjectListHeader'
import {
  integrationProjectListSelector,
  integrationProjectToShareSelector,
  setIntegrationToShareProjectsListFlag
} from 'src/features'

const IntegrationProjectList: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { loading, data } = useAppSelector(integrationProjectListSelector)
  const { flag: successShare } = useAppSelector(integrationProjectToShareSelector)

  useEffect(() => {
    if (successShare) {
      showNotification('success', t('developers.ProjectShareSuccess'))
      dispatch(setIntegrationToShareProjectsListFlag(false))
    }
  }, [successShare])

  return <CustomCard loading={loading}>
    <IntegrationTransactionListHeader />
    <CustomTable
      columns={integrationProjectsListColumns}
      dataSource={data}
    />
  </CustomCard>
}

export default IntegrationProjectList
